if (!customElements.get('td-material-information-specs-wrapper')) {
  class TdMaterialInformationSpecsWrapper extends HTMLElement {
    constructor() {
      super();
      
      this.CONTENT_SELECTOR = '[data-fabric-content]';
      this.RUB_COUNT_SELECTOR = '[data-fabric-rub-count]';
    }

    connectedCallback() {
      this.formatSpecContent();
    }

    formatSpecContent() {
        // Format content
        if (this.querySelectorAll(this.CONTENT_SELECTOR).length > 0) {
            this.querySelectorAll(this.CONTENT_SELECTOR).forEach((content) => {
                content.innerHTML = content.innerHTML
                .toLowerCase()
                .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
            });
        }
        
        // Format rub count
        if (this.querySelectorAll(this.RUB_COUNT_SELECTOR).length > 0) {
            this.querySelectorAll(this.RUB_COUNT_SELECTOR).forEach((rubCount) => {
                rubCount.innerHTML = rubCount.innerHTML
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            });
        }
    }
  }

  customElements.define('td-material-information-specs-wrapper', TdMaterialInformationSpecsWrapper);
}
